// Multi-select (BZL-59). Kept apart from box.status.selected, which stays the
// single scan the viewer shows: a selection is the set an action applies to,
// and the two must not be confused -- tapping a scan to look at it must never
// silently add it to what a bulk untag is about to touch.
export const selectionConstants = {
  ENTER: 'SELECTION_ENTER',
  EXIT: 'SELECTION_EXIT',
  TOGGLE: 'SELECTION_TOGGLE',
  RANGE: 'SELECTION_RANGE',
  SET: 'SELECTION_SET',
  CLEAR: 'SELECTION_CLEAR',
  PRUNE: 'SELECTION_PRUNE',
  RECORD_UNDO: 'SELECTION_RECORD_UNDO',
  CLEAR_UNDO: 'SELECTION_CLEAR_UNDO',
};

export const initialSelectionState = {
  // Selection mode is explicit, so a plain click keeps meaning "show me this".
  active: false,
  // Ordered by when they were added. Order matters for undo and for the bulk
  // bar's count; membership is checked against the index below.
  ids: [],
  byId: {},
  // The last scan clicked without shift, the far end of a shift-click range.
  anchor: null,
  // The most recent reversible bulk operation, or null.
  undo: null,
};
